import React from "react";
import {
  Button,
  IconButton,
  InputBase,
  Typography,
  makeStyles,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import { useNavigate } from "react-router-dom";
import SistemaContableContent from "./SistemaContableContent";

const useStyles = makeStyles((theme) => ({
  shell: {
    background: "#080f1f",
    color: "#f5f7fb",
    display: "grid",
    gridTemplateColumns: "220px minmax(0, 1fr)",
    minHeight: "100vh",
  },
  sidebar: {
    background: "#111827",
    borderRight: "1px solid #1d3454",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  brand: {
    alignItems: "center",
    borderBottom: "1px solid #1d3454",
    display: "flex",
    gap: theme.spacing(1),
    height: 58,
    padding: theme.spacing(0, 1.4),
  },
  brandMark: {
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& img": {
      display: "block",
      height: 26,
      objectFit: "contain",
      width: "auto",
    },
  },
  brandName: {
    color: "#f5f7fb",
    fontSize: 15,
    fontWeight: 900,
    letterSpacing: 0,
    lineHeight: 1,
  },
  brandSub: {
    color: "#02dfb1",
    fontSize: 9,
    fontWeight: 900,
    letterSpacing: 1,
    lineHeight: 1.3,
  },
  nav: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(2, 1),
  },
  sectionTitle: {
    color: "#53647e",
    fontSize: 10,
    fontWeight: 900,
    letterSpacing: 1.4,
    margin: theme.spacing(2, 1, 0.8),
    textTransform: "uppercase",
  },
  navItem: {
    alignItems: "center",
    border: "1px solid transparent",
    borderRadius: 7,
    color: "#b8cdf0",
    cursor: "pointer",
    display: "flex",
    fontSize: 13,
    gap: theme.spacing(1.1),
    justifyContent: "space-between",
    marginBottom: 6,
    padding: theme.spacing(1.1, 1),
    transition:
      "background 160ms ease, border-color 160ms ease, color 160ms ease",
    "&:hover": {
      background: "#0f2236",
      borderColor: "#1d3454",
      color: "#02dfb1",
    },
  },
  navItemActive: {
    background: "#0f3443",
    borderColor: "#0e6f85",
    color: "#02dfb1",
  },
  navLabel: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
    minWidth: 0,
  },
  navIcon: {
    display: "inline-flex",
    justifyContent: "center",
    width: 20,
  },
  badge: {
    alignItems: "center",
    background: "#02dfb1",
    borderRadius: 999,
    color: "#06101f",
    display: "inline-flex",
    fontSize: 11,
    fontWeight: 900,
    height: 18,
    justifyContent: "center",
    minWidth: 18,
    padding: theme.spacing(0, 0.6),
  },
  badgeDanger: {
    background: "#ff405d",
    color: "#ffffff",
  },
  sidebarFooter: {
    borderTop: "1px solid #1d3454",
    color: "#53647e",
    fontSize: 11,
    padding: theme.spacing(1.5, 1.8),
  },
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    minWidth: 0,
  },
  topbar: {
    alignItems: "center",
    background: "#111827",
    borderBottom: "1px solid #1d3454",
    display: "flex",
    gap: theme.spacing(1),
    height: 58,
    maxHeight: "none",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2.2),
  },
  pageTitle: {
    color: "#f5f7fb",
    fontSize: 20,
    fontWeight: 900,
  },
  topbarActions: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
  },
  search: {
    alignItems: "center",
    background: "#172138",
    border: "1px solid #243653",
    borderRadius: 7,
    color: "#8fb1d8",
    display: "flex",
    height: 36,
    padding: theme.spacing(0, 1.1),
    width: 222,
  },
  searchIcon: {
    color: "#8bbcff",
    fontSize: 18,
    marginRight: theme.spacing(0.8),
  },
  searchInput: {
    color: "#b8cdf0",
    fontSize: 13,
    width: "100%",
  },
  notifyButton: {
    background: "#172138",
    border: "1px solid #243653",
    borderRadius: 7,
    color: "#ffffff",
    height: 36,
    padding: 0,
    width: 52,
    "&:hover": {
      background: "#1b2942",
    },
  },
  newButton: {
    background: "linear-gradient(135deg, #02dfb1 0%, #19b8f2 100%)",
    borderRadius: 8,
    color: "#06101f",
    fontSize: 12,
    fontWeight: 900,
    height: 36,
    padding: theme.spacing(0, 1.4),
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(135deg, #02caa2 0%, #139ed2 100%)",
    },
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  moduleFooter: {
    alignItems: "center",
    background: "#0d172b",
    borderTop: "1px solid #1d3454",
    color: "#6d83a5",
    display: "flex",
    fontSize: 11,
    justifyContent: "space-between",
    minHeight: 34,
    padding: theme.spacing(0, 2.2),
    /* Neutralizar el position: fixed de base.css sobre la etiqueta <footer> */
    position: "static",
    left: "auto",
    bottom: "auto",
    width: "auto",
    height: "auto",
  },
}));

const SistemaContableShell = ({ currentResource, menuSections = [], selectResource, title }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const logo = "/facturarIsotipo.png";

  return (
    <div className={classes.shell}>
      <aside className={classes.sidebar}>
        <div className={classes.brand}>
          <div className={classes.brandMark}> <img src={logo} alt="Facturar PA"></img> </div>
          <div>
            <Typography className={classes.brandName}>FACTURAR PA</Typography>
            <Typography className={classes.brandSub}>
              CONTABILIDAD
            </Typography>
          </div>
        </div>

        <nav className={classes.nav}>
          {menuSections.map((section) => (
            <div key={section.title}>
              <Typography className={classes.sectionTitle}>
                {section.title}
              </Typography>
              {section.items.map((item) => {
                const active = currentResource.id === item.id;

                return (
                  <div
                    className={`${classes.navItem} ${
                      active ? classes.navItemActive : ""
                    }`}
                    key={item.id}
                    onClick={() => selectResource(item)}
                    role="button"
                    tabIndex={0}
                  >
                    <span className={classes.navLabel}>
                      <span className={classes.navIcon}>{item.icon}</span>
                      <span>{item.nameMenu}</span>
                    </span>
                    {item.badge && (
                      <span
                        className={`${classes.badge} ${
                          item.badgeTone === "danger" ? classes.badgeDanger : ""
                        }`}
                      >
                        {item.badge}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </nav>

        <div className={classes.sidebarFooter}>
          Facturar PA Contabilidad
          <br />
          Version 1.0
        </div>
      </aside>

      <section className={classes.main}>
        <header className={classes.topbar}>
          <Typography className={classes.pageTitle}>{title}</Typography>

          <div>
            <IconButton className={classes.notifyButton} onClick={() => navigate("/modulos")}>
              <HomeIcon fontSize="small" />
            </IconButton>
          </div>
        </header>

        <main className={classes.content}>
          <SistemaContableContent resource={currentResource} />
        </main>

        <footer className={classes.moduleFooter}>
          <span>Derechos Reservados BIGDATA C.A. &copy; {year}</span>
          <span>Modulo contable</span>
        </footer>
      </section>
    </div>
  );
};

export default SistemaContableShell;
